import { faCircle, faCircleDot } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RadioGroup } from '@mui/material';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import { TrlFormControlLabel, TrlRadioButton } from '»components/atoms';

import { CheckboxStyled } from '../atoms/Inputs/TrlCheckButton/TrlCheckButton.styles';
import { FormControlStyled, LabelStyled } from './Questionnaire.styles';

export const QuestionnaireOptions = ({
  options,
  label,
  isRequired,
  multiChoice,
  name,
}) => {
  const { setFieldValue, values } = useFormikContext();

  const handleChange = (event) => {
    if (multiChoice) {
      const { checked, value } = event.target;
      const currentArray = values[name].value;
      if (checked) {
        setFieldValue(`${name}.value`, [...currentArray, value]);
      } else {
        setFieldValue(
          `${name}.value`,
          currentArray.filter((item) => item !== value),
        );
      }
    } else {
      setFieldValue(`${name}.value`, event.target.value);
    }
  };

  return (
    <FormControlStyled id="questionContainer">
      <LabelStyled
        isRequired={isRequired}
        title={`${label}${isRequired ? ' *' : ''}`}
      >
        {label}
      </LabelStyled>
      {multiChoice ? (
        <>
          {options.map((option) => {
            const { id, label: optionLabel, responseValeu } = option;
            const isCheck = values[name].value.find((v) => v === responseValeu);
            return (
              <TrlFormControlLabel key={id} id={id} label={optionLabel}>
                <CheckboxStyled
                  onChange={handleChange}
                  value={responseValeu}
                  checked={isCheck}
                  checkedIcon={
                    <FontAwesomeIcon
                      icon={faCircleDot}
                      style={{ fontSize: '14px' }}
                    />
                  }
                  icon={
                    <FontAwesomeIcon
                      icon={faCircle}
                      style={{ fontSize: '14px' }}
                    />
                  }
                />
              </TrlFormControlLabel>
            );
          })}
        </>
      ) : (
        <RadioGroup
          name={name.toString()}
          value={values[name].value}
          onChange={handleChange}
        >
          {options.map((option) => {
            const { id, label: optionLabel, responseValeu } = option;

            return (
              <TrlFormControlLabel key={id} id={id} label={optionLabel}>
                <TrlRadioButton
                  id={id}
                  name={name.toString()}
                  value={responseValeu}
                />
              </TrlFormControlLabel>
            );
          })}
        </RadioGroup>
      )}
    </FormControlStyled>
  );
};

QuestionnaireOptions.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  multiChoice: PropTypes.bool,
  name: PropTypes.number,
};
